// generated by the plop

import { PaginateQuery, PaginatorModel } from 'symbols';
import {
  CategoryExpectBackendModel,
  FinanceScoreExpectBackendModel,
  TransactionExpectBackendModel,
  TransactionFilterModel,
  TransactionModel
} from '../../symbols';

export class GetCurrencies {
  static type = '[financeRegister] GetCurrencies';
}

export class GetFinanceScopes {
  static type = '[financeRegister] GetFinanceScopes';
}

export class GetCategoriesOfTransactions {
  static type = '[financeRegister] GetCategoriesOfTransactions';

  constructor(public date: string) {
  }
}


export class GetTransactionList {
  static type = '[financeRegister] GetTransactionList';

  constructor(public lazy?: boolean, public filter?: PaginateQuery<TransactionFilterModel>) {
  }
}

export class GetTransactionListSuccess {
  static type = '[financeRegister] GetTransactionListSuccess';

  constructor(public transactionList: PaginatorModel<TransactionModel>, public lazy: boolean) {
  }
}

export class GetTransactionListError {
  static type = '[financeRegister] GetTransactionListError';

  constructor(public error: any) {
  }
}

export class ChangeScorePosition {
  static type = '[financeRegister] ChangeScorePosition';

  constructor(public prevIndex: number, public currentIndex: number) {
  }
}

export class CreateTransferTransaction {
  static type = '[financeRegister] CreateTransferTransaction';

  constructor(public transaction: TransactionExpectBackendModel) {
  }
}

export class CreateTransaction {
  static type = '[financeRegister] CreateTransaction';

  constructor(public transaction: TransactionExpectBackendModel) {
  }
}


export class UpdateTransactionSuccess {
  static type = '[financeRegister] UpdateTransactionSuccess';
}


export class CreateTransactionSuccessWS {
  static type = '[financeRegister] CreateTransactionSuccessWS';
}


export class GetCategoryStatistics {
  static type = '[financeRegister] GetCategoryStatistics';

  constructor(public date: string) {
  }
}

export class UpdateTransaction {
  static type = '[financeRegister] UpdateTransaction';

  constructor(public transaction: TransactionExpectBackendModel, public id: string) {
  }
}

export class UpdateTransactionSuccessWS {
  static type = '[financeRegister] UpdateTransactionSuccessWS';
}

export class DeleteTransaction {
  static type = '[financeRegister] DeleteTransaction';

  constructor(public transactionId: string) {
  }
}

export class DeleteTransactionSuccessWS {
  static type = '[financeRegister] DeleteTransactionSuccessWS';
}

export class DeleteScore {
  static type = '[financeRegister] DeleteScore';

  constructor(public scoreId: string, public toScoreId: string) {
  }
}

export class CreateScore {
  static type = '[financeRegister] CreateScore';

  constructor(public score: FinanceScoreExpectBackendModel) {
  }
}

export class UpdateScore {
  static type = '[financeRegister] UpdateScore';

  constructor(public score: FinanceScoreExpectBackendModel, public scoreId: string) {
  }
}

export class CreateCategory {
  static type = '[financeRegister] CreateCategory';

  constructor(public category: CategoryExpectBackendModel) {
  }
}

export class DeleteCategory {
  static type = '[financeRegister] DeleteCategory';

  constructor(public categoryId: string) {
  }
}

export class UpdateCategory {
  static type = '[financeRegister] UpdateCategory';

  constructor(public category: CategoryExpectBackendModel, public categoryId: string) {
  }
}
